import { useQuery } from '@tanstack/react-query'

import { StaleTime } from '@core/query'
import { convertAudioPaginated } from '@core/converters'
import { CollectionQueryKey } from '../helpers/queryKeys'
import { getCollectionAudios } from '../services/getCollectionAudios'

export const useCollectionAudios = ({
    username,
    slug,
    page,
}: {
    username: string
    slug: string
    page: number
}) => {
    return useQuery({
        queryKey: CollectionQueryKey.collectionAudios(username, slug, page),
        queryFn: async () =>
            convertAudioPaginated(await getCollectionAudios({ username, slug, page })),
        staleTime: StaleTime.Long,
        enabled: Boolean(username && slug),
    })
}
